import React from "react";
import "./DefaultTab.css"; // your CSS including .ripple and animations

export default function DefaultTab({ children, active, onClick }) {
  const handleClick = (e) => {
    const tab = e.currentTarget;

    // create ripple element
    const ripple = document.createElement("span");
    ripple.className = "ripple";

    // size: max(width, height)
    const size = Math.max(tab.offsetWidth, tab.offsetHeight);
    ripple.style.width = ripple.style.height = size + "px";

    // position: center at click
    const rect = tab.getBoundingClientRect();
    ripple.style.left = e.clientX - rect.left - size / 2 + "px";
    ripple.style.top = e.clientY - rect.top - size / 2 + "px";

    // append and remove after animation
    tab.appendChild(ripple);
    ripple.addEventListener("animationend", () => ripple.remove());

    // call parent onClick if any
    if (onClick) onClick(e);
  };

  return (
    <button
      className={`default-tab ${active ? "active" : ""}`}
      onClick={handleClick}
    >
      {children}
    </button>
  );
}
